export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Share infrastructure work and deployment status', frequency: 'Daily at 9 AM' },
      { name: 'Code Reviews', description: 'Review infrastructure code and CI/CD configurations', process: 'All infrastructure changes require peer review' },
      { name: 'Sprint Planning', description: 'Plan infrastructure improvements and deployments', frequency: 'Bi-weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Team communication', channels: ['#devops-team', '#infrastructure', '#deployments'] },
      { name: 'Jira', purpose: 'Task tracking', access: 'Developer role with infrastructure projects' },
      { name: 'GitHub', purpose: 'Infrastructure as code', permissions: 'Read/Write on infrastructure repos' }
    ],
    processes: [
      { name: 'Infrastructure Changes', steps: ['Create Terraform plan', 'Peer review', 'Apply in staging', 'Test and validate', 'Apply to production'] },
      { name: 'Incident Response', steps: ['Acknowledge alert', 'Investigate issue', 'Implement fix', 'Document resolution'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Architecture Reviews', description: 'Review infrastructure architecture and scaling plans', frequency: 'Weekly' },
      { name: 'On-call Rotation', description: 'Participate in infrastructure on-call rotation', commitment: 'Weekly on-call shifts' },
      { name: 'Capacity Planning', description: 'Monitor and plan infrastructure capacity', responsibility: 'Resource utilization analysis' }
    ],
    tools: [
      { name: 'AWS Console', purpose: 'Cloud infrastructure management', access: 'PowerUser permissions' },
      { name: 'Datadog', purpose: 'Infrastructure monitoring', access: 'Admin permissions' },
      { name: 'PagerDuty', purpose: 'Incident management', access: 'Responder role' }
    ],
    processes: [
      { name: 'Performance Optimization', steps: ['Monitor metrics', 'Identify bottlenecks', 'Plan optimizations', 'Implement and measure'] },
      { name: 'Security Compliance', steps: ['Security scans', 'Vulnerability assessment', 'Remediation planning', 'Implementation'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Strategic Planning', description: 'Define infrastructure strategy and roadmap', responsibility: 'Infrastructure architecture ownership' },
      { name: 'Cross-team Leadership', description: 'Lead infrastructure initiatives across teams', scope: 'Company-wide infrastructure' },
      { name: 'Technology Evaluation', description: 'Evaluate and adopt new infrastructure technologies', impact: 'Technology stack decisions' }
    ],
    tools: [
      { name: 'AWS Console', purpose: 'Enterprise infrastructure management', access: 'Admin permissions' },
      { name: 'Terraform Cloud', purpose: 'Infrastructure automation', role: 'Organization admin' },
      { name: 'Splunk', purpose: 'Advanced monitoring and analytics', access: 'Admin permissions' }
    ],
    processes: [
      { name: 'Disaster Recovery', steps: ['Design DR strategy', 'Implement backup systems', 'Test recovery procedures', 'Document processes'] },
      { name: 'Cost Optimization', steps: ['Analyze spending', 'Identify savings opportunities', 'Implement optimizations', 'Monitor results'] }
    ]
  }
};
